<template>
  <div class="websit">
    <div class="flexbox-c header" >
      <Menu />
      <div class="websittitle" >MAKE YOUR LIFE MORE INTERESTING</div>
      <div class="flexbox-s loginbox">
        <img src="data:image/png;base64,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" alt="" class="logo">
        <a href="#/login" class="btn">{{$t('user.login')}}</a>
        <router-link :to="{name: 'Info', params: {query: 'register'}}" class="btn" >{{$t('user.register')}}</router-link>
      </div>
    </div>

    <div class="flexbox-c body" >
      <div class="infocontainer" >
        <template v-if="$route.params.query == 'about-us'">
          <template v-if="language == 'cn'">
            <div class="title1" >关于我们</div>
            <div class="title2" >公司简介</div>
            <div class="content" >本站致力于在230多个国家和地区开拓网上交友服务产业，并管理多种不同语言的网站。在这里您可以尽情的和朋友分享趣事和喜悦，为您提供一个全世界最快捷、最好玩的交友平台，每天都有成千上百新会员加入。{{other_page_remark}}</div>
            <div class="title2" >我们的使命是什么？</div>
            <div class="content" >我们的使命很简单：帮助大家认识来自全世界的朋友。我们认为：这方面我们做得相当不错。每个月我们都收到全世界各地的来信，与我们分享他们与在本站上认识的朋友的故事。</div>
            <div class="title2" >怎样操作？</div>
            <div class="content" >我们为用户提供认识及了解全世界朋友的机会，通过不同的自由编写版块，让他们在其档案中详细介绍他们自己。可以上传多张图片，以及有关他们的兴趣爱好。我们知道隐私保护的重要性，所以，会员间所有的联系都是通过匿名邮件网络进行的。我们对所有会员的姓名和联系信息都保密，除非会员自己想与对方分享个人信息的情况除外，一旦注册完成，会员可以立即浏览潜在朋友的照片与日志，并与其联系。</div>
          </template>
          <template v-else-if="language == 'tn'">
            <div class="title1">關於我們</div>
            <div class="title2">公司簡介</div>
            <div class="content">本站致力於在230多個國家和地區開拓網上交友服務產業，並管理多種不同語言的網站。在這裡您可以盡情的和朋友分享趣事和喜悅，為您提供一個全世界最快捷、最好玩的交友平台，每天都有成千上百新會員加入。{{other_page_remark}}</div>
            <div class="title2">我們的使命是什麼？</div>
            <div class="content">我們的使命很簡單：幫助大家認識來自全世界的朋友。我們認為：這方面我們做得相當不錯。每個月我們都收到全世界各地的來信，與我們分享他們與在本站上認識的朋友的故事。</div>
            <div class="title2">怎樣操作？</div>
            <div class="content">我們為用戶提供認識及了解全世界朋友的機會，通過不同的自由編寫版塊，讓他們在其檔案中詳細介紹他們自己。可以上傳多張圖片，以及有關他們的興趣愛好。我們知道隱私保護的重要性，所以，會員間所有的聯繫都是通過匿名郵件網絡進行的。我們對所有會員的姓名和聯繫信息都保密，除非會員自己想與對方分享個人信息的情況除外，一旦註冊完成，會員可以立即瀏覽潛在朋友的照片與日誌，並與其聯繫。</div>
          </template>
          <template v-else>
            <div class="title1">ABOUT US</div>
            <div class="title2">COMPANY PROFILE</div>
            <div class="content">Our website committed to develop online dating service industries in more than 230 countries and regions, and manage multiple websites in different languages. Here you can enjoy the fun and joy to share with friends, to provide you with a world's most efficient, most fun dating platform, every day hundreds of new members to join.{{other_page_remark}}</div>
            <div class="title2">WHAT IS OUR MISSION?</div>
            <div class="content">Our mission is simple: to help you make friends from around the world come from. We think: this regard, we are doing pretty good. Every month we have received letters from all over the world to share their knowledge with friends on Our website story with us.</div>
            <div class="title2">HOW TO OPERATE?</div>
            <div class="content">We provide knowledge and understanding of friends around the world the opportunity for users to write freely through the different pages, so that they themselves described in detail in its files. You can upload multiple pictures, and information about their hobbies. We know the importance of privacy, so all contact between members are via anonymous e-mail networks. We are all members of the names and contact information are confidential, unless the members, except they want to share personal information with each other, once registered, members can view photos immediately and logs potential friends and contact them.</div>
          </template>
        </template>
        <template v-else-if="$route.params.query== 'contact-us'">
          <template v-if="language == 'cn'">
            <div class="title1">联系我们</div>
            <div class="content">Company:
              <span>{{ contact_us_company }}</span>
              <br>Address:
              <span>{{contact_us_address}}</span>
              <br>Email: meet-fate@outlook.com</div>
          </template>
          <template v-else-if="language == 'tn'">
            <div class="title1">聯係我們</div>
            <div class="content">Company:
              <span>{{ contact_us_company }}</span>
              <br>Address:
              <span>{{contact_us_address}}</span>
              <br>Email: meet-fate@outlook.com</div>
          </template>
          <template v-else>
            <div class="content">Company:
              <span>{{ contact_us_company }}</span>
              <br>Address:
              <span>{{contact_us_address}}</span>
              <br>Email: meet-fate@outlook.com</div>
          </template>
        </template>
        <template v-else-if="$route.params.query== 'privacy-policy'">
          <template v-if="language == 'cn'">
            <div class="title1" >隐私政策</div>
            <div class="content" >本网站尊重用户的隐私权，并制定隐私政策，保护您的隐私权。隐私政策包括：本网站的用户情况，我们所收集的信息，怎样利用这些信息，以及与谁分享这些信息。当您使用我们的网站或服务，或与我们进行商务交易时，我们建议你仔细阅读“隐私政策”。通过使用我们的网站，表明您已接受本保密协议的规定。本网站非常重视网络隐私。如果您对该隐私政策有任何疑问，请联系我们。
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >未满18岁的人士</div>
            <div class="content" >本网站不会故意收集或保存未满18岁人士的个人验证信息或非个人验证信息，本网站下的任何项目均不面向未满18岁的人士开放。如果你未满18岁，请停止使用或禁止进入本网站或服务。如果本网站获悉所收集的信息中有未满18岁人士的个人验证信息，本网站将采取合理的步骤，删除该信息。</div>
            <div class="title2" >我们所收集的信息</div>
            <div class="content" >您填写的相关信息（包括您的个人信息，联系信息，以及当您创建会员档案时所填写的其他档案信息）；当你自由填写顾客调查表，提供反馈和参与竞争时，所提供的相关信息;如果您与我们联系，我们会记录你的通信信息;交易信息包括您从我们网站定购有关产品和服务的信息;浏览我们网站的访客，并且他们的信息已被记录的，可以有权以相同的信息登录，并有权更正信息或查看有关该信息的政策和规则。访客可以直接与我们联系。</div>
            <div class="title2" >其他方收集的信息</div>
            <div class="content" >我们允许第三方（包括我们的授权服务提供商，广告公司和广告网站）在我们的网站上发表广告。如果你打开一个链接（例如一个广告标志），这将使你将离开我们的网站，登录其他的网站，如果你随后在其他网站上提供信息，我们将不能控制该信息的使用。本隐私政策将不对其他网站或广告商的信息保密负责。对于其他网站如何使用你的信息，本网站也将不为此负担任何责任。</div>
            <div class="title2" >我们怎样使用收集的信息？</div>
            <div class="content" >管理您的用户账户（包括：通知您任何匹配的对象，提示，通告，更新资料或促销活动</div>
            <div class="content" >帮助你订制个性化的网站回访</div>
            <div class="content" >向您提供您所询问的信息，产品或服务，或者你感兴趣的信息；进行市场分析和调查</div>
            <div class="content" >帮助我们改进服务结构，布局和适用性</div>
            <div class="title2" >我们与谁分享所收集的信息</div>
            <div class="content" >我们可能在特定方面将您的信息与第三方分享，例如：当您从我们网站订制服务时，我们提供你的信息给第三方进行付款处理。但是我们将控制第三方使用您的信息，并对此负责。我们有可能将您的某些信息透露给我们的合作公司，以便向您提供服务，例如：邮件或聊天功能服务。为了提供这些服务，我们必须将您的信息（包括您的本网站用户名和email地址）提供给我们的合作伙伴。</div>
            <div class="title2" >COOKIES</div>
            <div class="content" >我们竭力按照您的喜好为您提供服务。我们使用Cookies 保存并记录有关于您的信息。 Cookie是指通过网络服务器发送到您浏览器的一小部分数据，该数据储存在您的计算机硬盘上。</div>
            <div class="title2" >变更隐私政策</div>
            <div class="content" >我们经常审核“隐私政策”，并在此页面公布政策的变更信息。我们鼓励会员经常审核我们的隐私政策，以便更好地了解我们所收集的信息，以及我们怎样运用信息，以及在何种情况下使用信息，与他人分享信息。</div>
            <div class="title2" >怎样联系我们</div>
            <div class="content" >如果您对于本隐私政策或对于我们的信息处理方式有何疑问，或对于我们透露信息给第三方（为了直销的目的）有疑问，请通过email或信件与联系我们。 E-mail: meet-fate@outlook.com</div>
          </template>
          <template v-else-if="language == 'tn'">
            <div class="title1" >隱私政策</div>
            <div class="content" >本網站尊重用戶的隱私權，並製定隱私政策，保護您的隱私權。隱私政策包括：用戶情況，我們所收集的信息，怎樣利用這些信息，以及與誰分享這些信息。當您使用我們的網站或服務，或與我們進行商務交易時，我們建議你仔細閱讀“隱私政策”。通過使用我們的網站，表明您已接受本保密協議的規定。 非常重視網絡隱私。如果您對該隱私政策有任何疑問，請聯繫我們。
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >未滿18歲的人士</div>
            <div class="content" >不會故意收集或保存未滿18歲人士的個人驗證信息或非個人驗證信息，本網站下的任何項目均不面向未滿18歲的人士開放。如果你未滿18歲，請停止使用或禁止進入本網站或服務。如果獲悉所收集的信息中有未滿18歲人士的個人驗證信息，本網站將採取合理的步驟，刪除該信息。</div>
            <div class="title2" >我們所收集的信息</div>
            <div class="content" >您填寫的相關信息（包括您的個人信息，聯繫信息，以及當您創建會員檔案時所填寫的其他檔案信息）；當你自由填寫顧客調查表，提供反饋和參與競爭時，所提供的相關信息;如果您與我們聯繫，我們會記錄你的通信信息;交易信息包括您從我們網站定購有關產品和服務的信息;瀏覽我們網站的訪客，並且他們的信息已被記錄的，可以有權以相同的信息登錄，並有權更正信息或查看有關該信息的政策和規則。訪客可以直接與我們聯繫。</div>
            <div class="title2" >其他方收集的信息</div>
            <div class="content" >我們允許第三方（包括我們的授權服務提供商，廣告公司和廣告網站）在我們的網站上發表廣告。如果你打開一個鏈接（例如一個廣告標誌），這將使你將離開我們的網站，登錄其他的網站，如果你隨後在其他網站上提供信息，我們將不能控制該信息的使用。本隱私政策將不對其他網站或廣告商的信息保密負責。對於其他網站如何使用你的信息，我站也將不為此負擔任何責任。</div>
            <div class="title2" >我們怎樣使用收集的信息？</div>
            <div class="content" >管理您的用戶賬戶（包括：通知您任何匹配的對象，提示，通告，更新資料或促銷活動</div>
            <div class="content" >幫助你訂製個性化的網站回訪</div>
            <div class="content" >向您提供您所詢問的信息，產品或服務，或者你感興趣的信息；進行市場分析和調查</div>
            <div class="content" >幫助我們改進服務結構，佈局和適用性</div>
            <div class="title2" >我們與誰分享所收集的信息</div>
            <div class="content" >我們可能在特定方面將您的信息與第三方分享，例如：當您從我們網站訂製服務時，我們提供你的信息給第三方進行付款處理。但是我們將控制第三方使用您的信息，並對此負責。我們有可能將您的某些信息透露給我們的合作公司，以便向您提供服務，例如：郵件或聊天功能服務。為了提供這些服務，我們必須將您的信息（包括您的用戶名和email地址）提供給我們的合作夥伴。</div>
            <div class="title2" >COOKIES</div>
            <div class="content" >我們竭力按照您的喜好為您提供服務。我們使用Cookies 保存並記錄有關於您的信息。 Cookie是指通過網絡服務器發送到您瀏覽器的一小部分數據，該數據儲存在您的計算機硬盤上。</div>
            <div class="title2" >變更隱私政策</div>
            <div class="content" >我們經常審核“隱私政策”，並在此頁面公佈政策的變更信息。我們鼓勵會員經常審核我們的隱私政策，以便更好地了解我們所收集的信息，以及我們怎樣運用信息，以及在何種情況下使用信息，與他人分享信息。</div>
            <div class="title2" >怎樣聯繫我們</div>
            <div class="content" >如果您對於本隱私政策或對於我們的信息處理方式有何疑問，或對於我們透露信息給第三方（為了直銷的目的）有疑問，請通過email或信件與聯繫我們。 E-mail: meet-fate@outlook.com</div>
          </template>
          <template v-else>
            <div class="title1" >PRIVACY POLICY</div>
            <div class="content" >meet-fate respect the privacy of users and to develop privacy policies to protect your privacy. Privacy policy include: user case meet-fate, we collect information, how to use this information and share this information with anyone. When you use our web site or service, or business transaction with us, we recommend that you carefully read the "Privacy Policy." By using our website, indicates that you have accepted the provisions of the confidentiality agreement. meet-fate online privacy very seriously. If you have any questions about this privacy policy, please contact us.
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >PERSONS UNDER 18 YEARS OF AGE</div>
            <div class="content" >meet-fate not knowingly collect or maintain under the age of 18 who personally identifiable information and non-personally identifiable information, any item on this site under the age of 18 who are not facing the open. If you are under 18, please stop using or prohibit access to the Site or the Service. If meet-fate learned the information collected under 18 years of age who personally identifiable information, this website will take reasonable steps to remove the information.</div>
            <div class="title2" >THE INFORMATION WE COLLECT</div>
            <div class="content" >You fill in the relevant information (including your personal information, contact information, and other file information when you create a member profile filled out); freedom when you fill out customer surveys, provide feedback and participate in the competition, provided the relevant information ; If you contact us, we will record your communication information; transaction information including your order from our website information about products and services; visit our website visitors, and their information has been recorded, may be entitled to the same login information and the right to correct information or to view the policies and rules of the relevant information. Visitors can contact us directly.</div>
            <div class="title2" >INFORMATION COLLECTED OTHERS</div>
            <div class="content" >We allow third parties (including our authorized service providers, advertising companies and advertising sites) in advertisements published on our website. If you open a link (such as an ad banner), which will allow you to leave our site, log in to other sites, if you subsequently provide information on other sites, we will not be able to control the use of this information. This Privacy Policy shall not be liable to other websites or advertisers information confidential. For other sites on how to use your information, meet-fate will not bear any responsibility for this purpose.</div>
            <div class="title2" >HOW DO WE USE THE INFORMATION COLLECTED?</div>
            <div class="content" >Manage your user account (including: inform you of any object that matches, tips, announcements, updates or promotions</div>
            <div class="content" >Help you customize a personalized website visit</div>
            <div class="content" >Are asked to provide your information, products or services, or information you are interested in; conduct market analysis and survey</div>
            <div class="content" >Help us improve our service structure, layout, and applicability</div>
            <div class="title2" >WE SHARE THE INFORMATION COLLECTED AND WHO</div>
            <div class="content" >We may be at particular aspects of sharing your information with third parties, such as: When you order the service from our website, we provide your information to a third party payment processing. But we will control the third party to use your information, and responsible. We have some of your information may be disclosed to our partner companies in order to provide you with services such as: e-mail or chat services. To provide these services, we have your information (including your username and email address meet-fate) to our partners.</div>
            <div class="title2" >COOKIES</div>
            <div class="content" >We tried to follow your preferences for your service. We use Cookies to save and recorded information about you. Cookie refers sent to your browser by a web server a small portion of the data, the data stored on your computer's hard drive.</div>
            <div class="title2" >PRIVACY POLICY CHANGES</div>
            <div class="content" >We regularly review the "Privacy Policy", and announced the policy change information on this page. We encourage members to regularly review our privacy policy to better understand the information we collect and how we use the information, and under what circumstances the use of information and share information with others.</div>
            <div class="title2" >HOW TO CONTACT US</div>
            <div class="content" >If you respect this privacy policy or our information handling any questions, or for us to disclose information to third parties (for direct marketing purposes) have questions, please contact us with email or letter. E-mail: meet-fate@outlook.com</div>
          </template>
        </template>
        <template v-else-if="$route.params.query== 'help-center'">
          <template v-if="language == 'cn'">
            <div class="title1" data-v-41066806="">帮助中心</div>
            <div class="title2" data-v-41066806="">1. 无法登陆网站</div>
            <div class="content" data-v-41066806="">请首先确认您是否成功注册meet-fate账号，然后确认您的账号密码输入是否正确，如果仍然无法登陆，请点击“忘记密码”，如仍然无法登陆，请及时联系网站管理员。</div>
            <div class="title2" data-v-41066806="">2. 忘记密码</div>
            <div class="content" data-v-41066806="">如果你忘记您的登陆密码，当你登陆的时候，请点击“忘记密码”选项，进行密码找回或是重置密码</div>
            <div class="title2" data-v-41066806="">3. 如何升级会员</div>
            <div class="content" data-v-41066806="">您可以点击升级会员图标按钮，然后选择你所要进行升级的会员等级进行升级。</div>
            <div class="title2" data-v-41066806="">4. 如何更好的使用翻译功能</div>
            <div class="content" data-v-41066806="">meet-fate网站是一个针对全球的SNS国际交友网站，在这里通过meet-fate翻译平台，让全球朋友沟通无限！当你拥有较高的会员权限，你将可以享有更多的翻译权限。</div>
            <div class="title2" data-v-41066806="">5. 如何举报非法账号</div>
            <div class="content" data-v-41066806="">当您发现一些非法账号，可以进入他的个人主页，点击“举报”。或是及时联系我们网站管理员，我们将会作出调查并进行处理，以确保网站的安全性。</div>
            <div class="title2" data-v-41066806="">6. 如何进行支付</div>
            <div class="content" data-v-41066806="">您可以登录meet-fate点击充值，我们目前提供所有的支付方式都是绝对安全的。本网站绝没有任何自动记忆或重复收费的程序。有任何疑问，请及时联系网站管理员提出您的问题。</div>
            <div class="title2" data-v-41066806="">7. 充值不成功</div>
            <div class="content" data-v-41066806="">如果您在meet-fate的充值页面无法成功充值，请先查看你的信用卡是否有问题，然后更换浏览器重新尝试。有时您也可以选择联 系贝宝（比如在系统提示"您的信用卡不能用于支付这笔交易"的情况下）。如果各种方法都尝试过后仍旧无法成功充值，请将详细情况告诉我们，比如您使用的是 哪种充值方式，有何错误提示？使用哪种浏览器？为了协助我们技术人员快速查找原因帮你解决问题，请您尽可能将出错页面截图发给我们网站管理员。</div>
          </template>
          <template v-else-if="language == 'tn'">
            <div class="title1" data-v-41066806="">幫助中心</div>
            <div class="title2" data-v-41066806="">1. 無法登陸網站</div>
            <div class="content" data-v-41066806="">請首先確認您是否成功註冊meet-fate賬號，然後確認您的賬號密碼輸入是否正確，如果仍然無法登陸，請點擊“忘記密碼”，如仍然無法登陸，請及時聯繫網站管理員。</div>
            <div class="title2" data-v-41066806="">2. 忘記密碼</div>
            <div class="content" data-v-41066806="">如果你忘記您的登陸密碼，當你登陸的時候，請點擊“忘記密碼”選項，進行密碼找回或是重置密碼。</div>
            <div class="title2" data-v-41066806="">3. 如何升級會員</div>
            <div class="content" data-v-41066806="">您可以點擊升級會員圖標按鈕，然後選擇你所要進行升級的會員等級進行升級。</div>
            <div class="title2" data-v-41066806="">4. 如何更好的使用翻譯功能</div>
            <div class="content" data-v-41066806="">meet-fate網站是一個針對全球的SNS國際交友網站，在這里通過meet-fate翻譯平台，讓全球朋友溝通無限！當你擁有較高的會員權限，你將可以享有更多的翻譯權限。</div>
            <div class="title2" data-v-41066806="">5. 如何舉報非法賬號</div>
            <div class="content" data-v-41066806="">當您發現一些非法賬號，可以進入他的個人主頁，點擊“舉報”。或是及時聯繫我們網站管理員，我們將會作出調查並進行處理，以確保網站的安全性。</div>
            <div class="title2" data-v-41066806="">6. 如何進行支付</div>
            <div class="content" data-v-41066806="">您可以登錄meet-fate點擊充值，我們目前僅提供PayPal、支付寶等網絡安全支付方式，所有的支付方式都是絕對安全的。本網站絕沒有任何自動記憶或重複收費的程序。有任何疑問，請及時聯繫網站管理員提出您的問題。</div>
            <div class="title2" data-v-41066806="">7. 充值不成功</div>
            <div class="content" data-v-41066806="">如果您在meet-fate的充值頁面無法成功充值，請先查看你的信用卡是否有問題，然後更換瀏覽器重新嘗試。有時您也可以選擇聯繫貝寶（比如在系統提示"您的信用卡不能用於支付這筆交易"的情況下）。如果各種方法都嘗試過後仍舊無法成功充值，請將詳細情況告訴我們，比如您使用的是哪種充值方式，有何錯誤提示？使用哪種瀏覽器？為了協助我們技術人員快速查找原因幫你解決問題，請您盡可能將出錯頁面截圖發給我們網站管理員。</div>
          </template>
          <template v-else>
            <div class="title1" data-v-41066806="">HELP CENTER</div>
            <div class="title2" data-v-41066806="">1. I CAN NOT LOG IN</div>
            <div class="content" data-v-41066806="">Please confirm whether you have successfully registered meet-fate account, and then confirm your account password is correct, if you still can not log in, please click on the "Forgot Password", such as still can not log in, please contact the webmaster.</div>
            <div class="title2" data-v-41066806="">2. FORGOT YOUR PASSWORD</div>
            <div class="content" data-v-41066806="">If you forget your login password when you log in, please click on the "Forgot Password" option to recover or reset passwords for password.</div>
            <div class="title2" data-v-41066806="">3. HOW TO UPGRADE MEMBERSHIP</div>
            <div class="content" data-v-41066806="">You can click on the upgrade membership icon button, then choose what you want to upgrade the membership level upgrade.</div>
            <div class="title2" data-v-41066806="">4. HOW TO BETTER USE THE TRANSLATION FEATURE</div>
            <div class="content" data-v-41066806="">meet-fate site is a global SNS for international dating sites, where by meet-fate translation platform for global communication and unlimited friends! When you have a higher membership privileges, you will be able to enjoy more of the translation privileges.</div>
            <div class="title2" data-v-41066806="">5. HOW TO REPORT ILLEGAL ACCOUNT</div>
            <div class="content" data-v-41066806="">When you find some illegal account, you can enter his personal home page, click "Report." Webmaster or contact us, we will make a survey and processed to ensure the safety of the site.</div>
            <div class="title2" data-v-41066806="">6. HOW TO PAY</div>
            <div class="content" data-v-41066806="">You can log meet-fate clicking recharge, we currently network security payment, all payment methods are absolutely safe. This website absolutely no memory of any automatic or recurring charges of procedure. Have any questions, please contact the webmaster Ask your questions.</div>
            <div class="title2" data-v-41066806="">7.RECHARGE UNSUCCESSFUL</div>
            <div class="content" data-v-41066806="">If you are unable to successfully recharge the prepaid page meet-fate, first check your credit card if there is a problem, then replace the browser and try again. Sometimes you can also choose to contact PayPal (eg prompted "on your credit card can not be used to pay the transaction " case). After a variety of methods to try if still unable to successfully recharge, please tell us the details, such as what you are using prepaid way, what error message? What kind of browser? In order to help our technical staff to quickly find the cause to help you solve the problem, you will send us a screenshot of the error page as the site administrator.</div>
          </template>
        </template>
        <template v-else-if="$route.params.query== 'terms-of-use'">
          <template v-if="language == 'cn'">
            <div class="title1" >服务条款</div>
            <div class="title2" >1. 同意服务条款</div>
            <div class="content" >本协议（使用条款），包括目前和未来的商业网站和客户。通过使用本服务，无论您是否注册为网站会员（以下简称会员），您都将被视为已同意本使用条款。如果您不同意本服务条款，请停止使用我们的服务。
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >2. 资格要求</div>
            <div class="content" >未满18岁的未成年人不得使用我们的服务。通过使用我们的服务，您声明并保证您有权利和能力遵守使用条款的所有规定。</div>
            <div class="title2" >3. 使用条款变更</div>
            <div class="content" >本网站保留更改本使用条款的权利，恕不另行通知。您可以查看服务条款以定期更改情况。当我们更改使用条款时，如果您使用我们的服务，无论您是否认为您同意这些更改。</div>
            <div class="title2" >4. 隐私</div>
            <div class="content" >我们的网站尊重网站访问者的隐私。使用该服务应遵守我们的隐私政策。我们的网站合作伙伴同意遵守隐私政策的规定. GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.</div>
            <div class="title2" >5. 服务变更</div>
            <div class="content" >我们的网站可以决定添加，删除或修改服务或服务，恕不另行通知。</div>
            <div class="title2" >6. 特色服务</div>
            <div class="title3" >A) 支付</div>
            <div class="content" >支付信息将作为您同意购买的服务产生的费用进行传输，结果将由您与金融机构、信用卡发卡机构或您选择的其他支付服务提供商之间的返回信息决定。如果我们的网站不接受您的支付服务提供商提供的支付服务，您可以支付您需要的所有金额，并同意继续使用我们的服务。如果您的帐户已付款，您可以要求我们取消您的付款状态。一旦您的帐户被取消，您的付款状态将在您的最终付款日期到期。付费状态不可转让。我们网站的付款状态是最终销售，不能退款。会员在当月或季度到期后不会自动扣除持卡人的续费。如果会员想继续使用，需要手动充值。有争议的费用应在您购买服务后60天内报告给我们的网站。如果您对您的付费状态有任何疑问，请联系我们解决。</div>
            <div class="title3" >B) 服务合同</div>
            <div class="content" >您在我们的网站订购服务将不会自动续订。您可以随时联系我们的客户服务团队进行更改或重新订购。如果您选择订购，您的订单将在服务未自动续订时过期。过期前取消定做，无法获得退款。</div>
            <div class="title3" >C)免费试用及其他促销</div>
            <div class="content" >任何免费试用或其他促销方式，均可在特定试用期内定制使用我们的服务。如果用户需要订购促销服务条款，则应在试用期前取消订单，以避免交付定制费用。</div>
            <div class="title2" >7. 通过合作伙伴加入我们的网站</div>
            <div class="content" >如果您通过我们的合作伙伴注册使用我们的服务，我们的网站将与其合作伙伴一起提供服务。您将有权使用会员服务，并有权向我们网站转让您的会员资格或付费向我们网站转让您的账户类似的服务。</div>
            <div class="title2" >8. 社区内容</div>
            <div class="content" >所有服务应遵循社区内容指南的要求。您同意不发布、传输、分发或链接任何涉及非法、骚扰、诽谤、威胁、有害、淫秽、叛逆、诽谤、诽谤他人名誉和侵犯他人隐私的内容，也不向他人发送不高兴的内容，更确切地说是针对其他人权团体或内容。知识产权未经本人书面同意，不得使用他人的知识产权，包括受著作权和商标保护的信息，不得对他人的知识产权进行变更或变更，如非著作权的文字、图片等。我们网站不会对任何由会员或团体发送的邮件内容负责，任何信息、商品或服务均不对第三方或会员负责。使用我们的服务，您同意：在以下情况下，我们的网站将不对您或他人负责：例如：对任何一方的威胁、诽谤、淫秽、猥亵、攻击或冒犯，或侵权，包括非法使用知识产权。我们的网站没有您提供给我们的所有信息（包括反馈和建议），或者您发布我们的网站、下载、输入或提交所有信息（“提交的信息”）。但是，如果您在我们的网站或客户上发布、上传、输入、提供或提交信息，您表示您给予我们的网站永久和不可撤销的转让权，我们的网站有权复制、使用、存储、修改、编辑、翻译或发布您提交的任何或所有信息，而且没有支付版税的信息。我们的网站没有义务发布或使用您提交的信息，我们的网站可以随时决定删除您提交的信息。在本网站中，您下载、输入或提交的信息表明您可以控制信息的发布。对于您的信息被删除、无效或未能保存，我们网站及其合作伙伴将不承担任何责任。</div>
            <div class="title2" >9. 会员账号</div>
            <div class="content" >一旦您注册我们的服务，您将收到一个帐号和密码，您有责任对您的帐号和密码保密，并应负责与您的帐号有关的所有活动。一旦注册成为会员，您将负责您的所有信息文件。禁止在文件或网络服务项目中发布色情或其他淫秽内容，因为这会威胁您的会员资格。对于下线交友网站会员我们网站，我们网站将不承担任何责任。您同意我们网站向您发送邮件（涉及服务信息（包括升级变更）、新功能或事件、使用服务的意见和建议）。</div>
            <div class="title2" >10. 受版权和商标保护的材料</div>
            <div class="content" >我们网站的内容受版权保护© 2023.</div>
            <div class="title2" >11. 免责声明</div>
            <div class="content" >在我们的网站或由我们的网站（或我们的网站代理商或合作伙伴）发布的信息，根据“现有”和“现有”报价。它提供各种明示或暗示的保证和条件。我们的网站不控制第三方提供的任何信息、产品或服务。您明确同意使用本服务将独自承担风险。在适用法律允许的最大范围内：我们网站上所有明示或暗示的保证、免责声明和此类保证，包括但不限于暗示的适销性，并确保适用于特殊用途；我们的网站不保证所提供的服务能满足您的需求，也不保证服务会不间断、及时、安全或正确。我们的网站不用于服务和使用结果作为抵押品。我们的网站不保证本网站或服务不包含任何病毒或其他有害成分。本网站不保证或声明：对网站转让信息保密。我们的网站不保证翻译的准确性和完整性。我们的网站不保证以下内容：通过本网站购买或获得的任何商品或服务，或在本网站上做广告或赞助商品或服务，或通过本网站进行的任何交易。信息我们的网站不是您从我们的网站收到服务或作出任何明示保证（无论是口头或书面）。</div>
          </template>
          <template v-else-if="language == 'tn'">
            <div class="title1" >服務條款</div>
            <div class="title2" >1. 同意服務條款</div>
            <div class="content" >本協定（使用條款），包括現時和未來的商業網站和客戶。通過使用本服務，無論您是否注册為網站會員（以下簡稱會員），您都將被視為已同意本使用條款。如果您不同意本服務條款，請停止使用我們的服務。
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >2. 資格要求</div>
            <div class="content" >未滿18歲的未成年人不得使用我們的服務。通過使用我們的服務，您聲明並保證您有權利和能力遵守使用條款的所有規定。</div>
            <div class="title2" >3. 使用條款的變更</div>
            <div class="content" >本網站保留更改本使用條款的權利，恕不另行通知。您可以查看服務條款以定期更改情况。當我們更改使用條款時，如果您使用我們的服務，無論您是否認為您同意這些更改。</div>
            <div class="title2" >4. 隱私</div>
            <div class="content" >我們的網站尊重網站訪問者的隱私。使用該服務應遵守我們的隱私政策。我們的網站合作夥伴同意遵守隱私政策的規定. GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.</div>
            <div class="title2" >5. 服務變更</div>
            <div class="content" >我們的網站可以决定添加，删除或修改服務或服務，恕不另行通知。</div>
            <div class="title2" >6. 特色服務</div>
            <div class="title3" >A) 付款</div>
            <div class="content" >支付資訊將作為您同意購買的服務產生的費用進行傳輸，結果將由您與金融機構、信用卡髮卡機构或您選擇的其他支付服務提供者之間的返回資訊决定。如果我們的網站不接受您的支付服務提供者提供的支付服務，您可以支付您需要的所有金額，並同意繼續使用我們的服務。如果您的帳戶已付款，您可以要求我們取消您的付款狀態。一旦您的帳戶被取消，您的付款狀態將在您的最終付款日期到期。付費狀態不可轉讓。我們網站的付款狀態是最終銷售，不能退款。會員在當月或季度到期後不會自動扣除持卡人的續費。如果會員想繼續使用，需要手動充值。有爭議的費用應在您購買服務後60天內報告給我們的網站。如果您對您的付費狀態有任何疑問，請聯繫我們解决。</div>
            <div class="title3" >B) 服務合同</div>
            <div class="content" >您在我們的網站訂購服務將不會自動續訂。您可以隨時聯繫我們的客戶服務團隊進行更改或重新訂購。如果您選擇訂購，您的訂單將在服務未自動續訂時過期。過期前取消定做，無法獲得退款。</div>
            <div class="title3" >C)免費試用及其他促銷</div>
            <div class="content" >任何免費試用或其他促銷管道，均可在特定試用期內定制使用我們的服務。如果用戶需要訂購促銷服務條款，則應在試用期前取消訂單，以避免交付定制費用。</div>
            <div class="title2" >7. 通過合作夥伴加入我們的網站</div>
            <div class="content" >如果您通過我們的合作夥伴注册使用我們的服務，我們的網站將與其合作夥伴一起提供服務。您將有權使用會員服務，並有權向我們網站轉讓您的會員資格或付費向我們網站轉讓您的帳戶類似的服務。</div>
            <div class="title2" >8. 社區內容</div>
            <div class="content" >所有服務應遵循社區內容指南的要求。您同意不發佈、傳輸、分發或連結任何涉及非法、騷擾、誹謗、威脅、有害、淫穢、叛逆、誹謗、誹謗他人名譽和侵犯他人隱私的內容，也不向他人發送不高興的內容，更確切地說是針對其他人權團體或內容。知識產權未經本人書面同意，不得使用他人的知識產權，包括受著作權和商標保護的資訊，不得對他人的知識產權進行變更或變更，如非著作權的文字、圖片等。我們網站不會對任何由會員或團體發送的郵件內容負責，任何資訊、商品或服務均不對協力廠商或會員負責。使用我們的服務，您同意：在以下情况下，我們的網站將不對您或他人負責：例如：對任何一方的威脅、誹謗、淫穢、猥褻、攻擊或冒犯，或侵權，包括非法使用知識產權。我們的網站沒有您提供給我們的所有資訊（包括迴響和建議），或者您發佈我們的網站、下載、輸入或提交所有資訊（“提交的資訊”）。但是，如果您在我們的網站或客戶上發佈、上傳、輸入、提供或提交資訊，您表示您給予我們的網站永久和不可撤銷的轉讓權，我們的網站有權複製、使用、存儲、修改、編輯、翻譯或發佈您提交的任何或所有資訊，而且沒有支付版稅的資訊。我們的網站沒有義務發佈或使用您提交的資訊，我們的網站可以隨時决定删除您提交的資訊。在本網站中，您下載、輸入或提交的資訊表明您可以控制資訊的發佈。對於您的資訊被删除、無效或未能保存，我們網站及其合作夥伴將不承擔任何責任。</div>
            <div class="title2" >9. 會員帳戶</div>
            <div class="content" >一旦您注册我們的服務，您將收到一個帳號和密碼，您有責任對您的帳號和密碼保密，並應負責與您的帳號有關的所有活動。一旦注册成為會員，您將負責您的所有資訊檔案。禁止在檔案或網絡服務專案中發佈色情或其他淫穢內容，因為這會威脅您的會員資格。對於下線交友網站會員我們網站，我們網站將不承擔任何責任。您同意我們網站向您發送郵件（涉及服務資訊（包括陞級變更）、新功能或事件、使用服務的意見和建議）。</div>
            <div class="title2" >10. 受版權和商標保護的資料</div>
            <div class="content" >我們網站的內容受版權保護© 2023.</div>
            <div class="title2" >11. 免責聲明</div>
            <div class="content" >在我們的網站或由我們的網站（或我們的網站代理商或合作夥伴）發佈的資訊，根據“現有”和“現有”報價。它提供各種明示或暗示的保證和條件。我們的網站不控制協力廠商提供的任何資訊、產品或服務。您明確同意使用本服務將獨自承擔風險。在適用法律允許的最大範圍內：我們網站上所有明示或暗示的保證、免責聲明和此類保證，包括但不限於暗示的適銷性，並確保適用於特殊用途；我們的網站不保證所提供的服務能滿足您的需求，也不保證服務會不間斷、及時、安全或正確。我們的網站不用於服務和使用結果作為抵押品。我們的網站不保證本網站或服務不包含任何病毒或其他有害成分。本網站不保證或聲明：對網站轉讓資訊保密。我們的網站不保證翻譯的準確性和完整性。我們的網站不保證以下內容：通過本網站購買或獲得的任何商品或服務，或在本網站上做廣告或贊助商品或服務，或通過本網站進行的任何交易。資訊我們的網站不是您從我們的網站收到服務或作出任何明示保證（無論是口頭或書面）。</div>
          </template>
          <template v-else>
            <div class="title1" >TERMS OF USE</div>
            <div class="title2" >1. AGREE TO TERMS OF USE</div>
            <div class="content" >This Agreement (Terms of Use), including present and future business website and the client. By using this service, whether or not you register as a website members (hereinafter referred to as members), you will be deemed to have agreed to these terms of use. If you do not agree to this Terms of Service, please stop using our services.
              <span>{{other_page_remark}}</span>
            </div>
            <div class="title2" >2. ELIGIBILITY REQUIREMENTS</div>
            <div class="content" >Minors under the age of 18 years shall not use our services. By using our service, you represent and warrant that you have the right and ability to comply with all the provisions of the Terms of Use.</div>
            <div class="title2" >3. CHANGES TO THE TERMS OF USE</div>
            <div class="content" >Our website reserves the right without prior notice, to change these Terms of Use. You can view the Terms of Service to change the situation on a regular basis. When we make changes to the terms of use, if you use our services, whether or not you view that you agree to these changes.</div>
            <div class="title2" >4. PRIVACY</div>
            <div class="content" >Our website respect the privacy of site visitors. Using the service should follow our privacy policy. Our website partners agreed to follow the provisions of the privacy policy. GOVERNING LAW- These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the HK laws.</div>
            <div class="title2" >5. SERVICE CHANGE</div>
            <div class="content" >Our website can decide to add, delete or modify services or the services without prior notice.</div>
            <div class="title2" >6.CUSTOM</div>
            <div class="title3" >A) PAYMENT</div>
            <div class="content" >Payment information will be transmitted as a fee incurred by the service you have agreed to purchase, and the result will be determined by the return information between you and a financial institution, a credit card issuer or other payment service provider of your choice. If our website does not accept payment services provided by your Payment Service Provider, you can pay all the amount you need and agree to continue using our services. If your account has been paid, you can ask us to cancel the status of your payment. Once your account has been cancelled, your payment status will expire on the date of your final payment. The paid status is not transferable. The paid status of Our website is final sales, and no refund can be made. Members will not automatically deduct the cardholder's renewal fee after the expiry of the month or quarter. If members want to continue to use it, they need to recharge it manually. The disputed fee should be reported to Our website within 60 days after you purchase the service. If you have any questions about your paid status, please contact us for settlement.</div>
            <div class="title3" >B) SERVICE CONTRACT</div>
            <div class="content" >You order at Our website site service will not automatically renew. You can contact our customer service team at any time to change or re-ordered. If you choose to order, your order will expire at the service does not automatically renew. Canceled before the expiry custom-made, can not get a refund.</div>
            <div class="title3" >C)FREE TRIAL AND OTHER PROMOTIONAL</div>
            <div class="content" >Any free trial or other promotional methods, can be customized to use our services in a specific trial period. If users need to order promotional service provisions, you should cancel the order before the trial period in order to avoid delivery of custom fees.</div>
            <div class="title2" >7. JOIN OUR WEBSITE THROUGH PARTNERS</div>
            <div class="content" >If you register to use our services through partners Our website, and Our website with its partners to provide the service. You will have the right to use members of the service, and Our website the right to transfer your membership or paid to transfer your account to the Our website similar services.</div>
            <div class="title2" >8. COMMUNITY CONTENT</div>
            <div class="content" >All services should follow the requirements of community content guidelines. You agree not to publish, transmit, distribute or link to anything involving unlawful, harassing, defamatory, threatening, harmful, obscene, rebellious, libel, slander the reputation of others, and violations of the privacy of others of the content, nor send other people unhappy, or rather against other human rights groups or content. Intellectual property without the written consent of the person shall not use the intellectual property of others, including information protected by copyright and trademark protection, alteration or change of intellectual property rights of others, such as non-copyright text or pictures. Our website will not be any mail sent by members or groups responsible for the content of the discussion thread, any information, goods or services are not responsible for third party or members of. Use our services, you agree that: In the following cases, Our website will not be responsible to you or others: for example: a threat to any party, defamatory, obscene, indecent, attack or offense, or tort, including the illegal use of knowledge property rights. Our website does not have all the information you provide to (including feedback and suggestions), or you publish Our website, download, input or submit all the information ("submitted information"). However, if you posted on our Web site or client, uploading, inputting, providing or submitting information, you indicate that you give Our website perpetual and irrevocable right to transfer, Our website the right to copy, use, store, modify, edit, translate or publish any or all of the information you have submitted, and without payment of royalties information. Our website no obligation to post or use the information you submit and Our website can always decide to delete the information you have submitted. In this website you download, input or submit information that indicates that you have your control over the release of information. For your information is deleted, invalid or failure to store, Our website and its partners will not be held responsible.</div>
            <div class="title2" >9. MEMBER ACCOUNT</div>
            <div class="content" >Once you sign up for our service, you will receive an account number and password, you are responsible for your account and password confidential, and shall be responsible for all activities related to your account. Once registered as a member, you will be responsible for all of your information files. Prohibited publication of pornographic or other obscene content in the file or web service project, because it would threaten your membership. For the next line dating site members Our website, Our website will not take any responsibility. You agree Our website send mail (involving service information (including changes to upgrade), new features or events, use the services of the observations and recommendations) to you.</div>
            <div class="title2" >10. MATERIALS PROTECTED BY COPYRIGHT AND TRADEMARK PROTECTION</div>
            <div class="content" >Content Our website are protected by copyright Copyright © 2023.</div>
            <div class="title2" >11. DISCLAIMER</div>
            <div class="content" >In Our website or published by Our website (or Our website agents or partners) information, according to "existing" and "existing" offer. It does all kinds of express or implied warranties and conditions. Our website does not control any information, products or services provided by third parties. You expressly agree that use of the service will bear the risk alone. The fullest extent permissible pursuant to applicable law: Our website on all express or implied warranties, disclaimers, and such warranty including but not limited to implied merchantability and ensure suitability for special purposes; Our website does not guarantee provided service to meet your needs, does not guarantee the service will be uninterrupted, timely, secure or correct. Our website not for service use and use the results as collateral. Our website does not warrant that this website or services does not contain any viruses or other harmful components. Our website does not warrant or represent that: keep the site transfer information confidential. Our website website does not guarantee the accuracy and completeness of the translation. Our website do not guarantee the following: any goods or services purchased or obtained through this website, or to advertise on this site or sponsorship of goods or services, or any transaction conducted through this website. Information Our website not you receive services from Our website or make any express warranties (whether oral or written).</div>
          </template>
        </template>
        <template v-else>
          <div class="flexbox-c bodycontainer" >
            <div class="formtitle">{{ $t('user.join_our') }}</div>
            <div class="formbody" >
              <div class="formcontent" >{{ $t('user.join_our2') }}</div>
              <div class="boxhead"  style="margin-bottom: 15px; border: 0px;">
                <i class="el-icon-user-solid">
                </i>
                <div class="registtitle">{{ $t('user.register_profile') }}</div>
              </div>
              <div class="boxhead" >
                <div class="formitemtitle">{{ $t('user.basic') }}</div>
              </div>
              <div class="boxbody">
                <div class="boxitem">
                  <div class="left">{{ $t('user.username') }}</div>
                  <div class="center">
                    <el-input v-model="username" maxlength="12" autocomplete="off" :placeholder="$t('user.username')"></el-input>
                  </div>
                  <div class="right">{{ $t('user.should_contain_only_letters_and_digits') }}</div>
                </div>
                <div class="boxitem">
                  <div class="left">{{ $t('user.email') }}</div>
                  <div class="center">
                    <el-input v-model="email"  autocomplete="off" :placeholder="$t('user.email')"></el-input>
                  </div>
                  <div class="right">{{ $t('user.should_be_valid') }}</div>
                </div>
                <div class="boxitem">
                  <div class="left">{{ $t('user.line') }}</div>
                  <div class="center">
                    <el-input v-model="lienId" autocomplete="off" :placeholder="$t('user.line')"></el-input>
                  </div>
                  <div class="right">
                  </div>
                </div>
                <div class="boxitem" >
                  <div class="left" >{{ $t('user.password') }}</div>
                  <div class="center">
                    <el-input v-model="password" maxlength="18" type="password" autocomplete="off" :placeholder="$t('user.password')"></el-input>
                  </div>
                  <div class="right" >
                  </div>
                </div>
                <div class="boxitem">
                  <div class="left" >{{ $t('user.sex') }}</div>
                  <div class="center" style="justify-content: flex-start;">
                    <el-radio-group v-model="sex">
                      <el-radio :label="1">{{$t('user.male')}}</el-radio>
                      <el-radio :label="0">{{$t('user.female')}}</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="right" >
                  </div>
                </div>
                <div class="boxitem" >
                  <div class="left">{{ $t('user.birthday') }}</div>
                  <div class="center" style="justify-content: flex-start;">
                    <el-select v-model="day">
                      <el-option
                          v-for="item in days"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                    <el-select v-model="month">
                      <el-option
                          v-for="item in months"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                    <el-select v-model="year">
                      <el-option
                          v-for="item in years"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="right">
                  </div>
                </div>
                <div class="boxitem">
                  <div class="left">
                    <router-link :to="{name: 'Info', params: {query: 'terms-of-use'}}" class="terms">{{ $t('user.terms_of_use') }}</router-link>
                  </div>
                  <div class="center" style="justify-content: flex-start;">
                    <el-checkbox  v-model="isCheck" name="type">{{$t('user.i_agree_with_it')}}</el-checkbox>
                  </div>
                  <div class="right">
                  </div>
                </div>
              </div>
              <div class="flexbox formbuttoncontainer" >
                <div class="flexbox loginbtn" @click="registerBtn">
                  <div >{{ $t('user.register') }}</div>|
                  <i class="iconfont icon-youjiantou"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import Menu from '@/components/Menu.vue'
import {mapGetters} from 'vuex'
import {login} from "@/api/user";
export default {
  components: { Footer,Menu },
  data() {
    return {
      language: "cn",
      type: '',
      days: 31,
      months: 12,
      years: [],
      day: 1,
      month: 1,
      year: 1990,
      username: '',
      password: '',
      email: '',
      lienId: '',
      sex: 1,
      isCheck: true,
      contact_us_company: window.contact_us_company,
      contact_us_address: window.contact_us_address,
      other_page_remark: window.other_page_remark,
    }
  },
  computed:{
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage: {
      handler(newV){
        console.log("new v = " + newV)
        this.changeLang(newV)
      },
      immediate: true
    }
  },
  props:['query'],
  created() {
    let years = []
    for (let i = 1973; i < 2007; i ++) {
      years.push(i)
    }
    this.years  = years
  },
  mounted() {
    this.type = this.$route.params
    console.log(this.type)
    this.language = this.getLanguage
  },
  methods: {
    registerBtn(){
      if(this.username.length <= 0){
        this.$message({
          message: this.$t('user.please_enter') + ' ' + this.$t('user.username'),
          type: 'warning'
        })
        return false
      }
      if(this.password.length <= 0){
        this.$message({
          message: this.$t('user.please_enter') + ' ' + this.$t('user.password'),
          type: 'warning'
        })
        return false
      }
      if(this.email.length <= 0){
        this.$message({
          message: this.$t('user.please_enter') + ' ' + this.$t('user.email'),
          type: 'warning'
        })
        return false
      }
      if(this.lienId.length <= 0){
        this.$message({
          message: this.$t('user.please_enter') + ' ' + this.$t('user.line'),
          type: 'warning'
        })
        return false
      }
      if(!this.isCheck){
        return false
      }
      const that = this
      let age = Math.floor((((new Date().getTime()) - (new Date(this.year, this.month, this.day).getTime())) / 86400 / 1000/ 365))
      let data = {
        username: this.username,
        password: this.password,
        type: 1,
        born: `${this.year}-${this.month < 10 ? '0' + this.month : this.month}-${this.day < 10 ? '0' + this.day : this.day}`,
        age: age,
        email: this.email,
        lienId: this.lienId,
        sex: this.sex,
        salesman_id: localStorage.getItem('salesman_id') ? localStorage.getItem('salesman_id') : 0
      }
      login(data).then(res => {
        if(res.code != 0){
          this.$message.error('Register failed');
          return false
        }else{
          this.$store.commit('setUserInfo', res.user)
          this.$store.commit('loginState', true)
          this.$message({
            message: 'Register successful',
            type: 'success'
          });
          sessionStorage.setItem('token', res.user.token)
          sessionStorage.setItem('user_id', res.user.id)
          sessionStorage.setItem('loginState', true)
          that.$router.push({name: 'Home'})
          return false
        }
      })
    },
    changeLang(lang) {
      this.language = lang
    }
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.websit {
  background-color: #9c6d97;
  background-image: linear-gradient(#8a7ea9,#9e769e,#9a729a);
  background-position: 0 0;
  background-repeat: repeat-x;
}
.header {
  width: 100%;
  height: 500px;
  background-image: url(../assets/img/bg1.jpg);
  background-size: cover;
  background-position: 50%;
  align-content: space-between;
}
.flexbox-c {
  justify-content: center;
}
.flexbox-c, .flexbox-s {
  display: flex;
  width: 100%;
  height: auto;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
}

.websittitle{
  color: #fff;
  font-size: 50px;
  margin-top: 150px;
  padding-right: 100px;
  font-family: Times New Roman,Times,serif;
}

.loginbox {
  width: 100%;
  height: 75px;
  background: hsla(0,0%,100%,.3);
  align-self: flex-end;
  padding-top: 20px;
}

.flexbox-s {
  justify-content: flex-start;
}


.loginbox {
  width: 100%;
  height: 75px;
  background: hsla(0,0%,100%,.3);
  align-self: flex-end;
  padding-top: 20px;
}
.logo {
  width: 40px;
  height: 40px;
  margin-right: 60px;
  margin-left: 15px;
}
.btn {
  padding-top: 10px;
  padding-right: 20px;
  font-size: 21px;
  color: #513b5a;
}
.body {
  min-width: 1000px;
  min-height: 400px;
}
.infocontainer {
  width: 1000px;
  padding: 70px 0;
  text-align: left;
}
.title1 {
  margin-bottom: 28px;
  font-size: 20px;
}
.title2{
  font-size: 16px;
  line-height: 30px;
}
.content {
  color: #fff;
  font-size: 14px;
}
.title1, .title2, .title3 {
  color: #513b5a;
  font-weight: 700;
  margin: 5px 0;
}

.bodycontainer {
  width: 1000px;
}
.bodycontainer .formtitle {
  width: 100%;
  color: #513b5a;
  font-weight: 700;
  margin-top: 50px;
  margin-bottom: 30px;
  font-size: 20px;
}

.bodycontainer .formbody{
  width: 800px;
}
.bodycontainer .formcontent {
  width: 100%;
  word-wrap: break-word;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 14px;
}
.bodycontainer .boxhead{
  display: flex;
  background: hsla(0,0%,100%,.2) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==) repeat-x 0 0;
  border: none;
  border-radius: 6px 6px 0 0;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  padding-left: 10px;
  border: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .registtitle {
  color: #513b5a;
  width: 100%;
  padding: 10px;
}
.bodycontainer .formitemtitle{
  color: #fff;
  width: 100%;
  padding: 10px;
  text-align: center;
}
.bodycontainer .boxbody {
  background: hsla(0,0%,100%,.05) url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==) repeat-x 0 0;
  margin-bottom: 10px;
}
.bodycontainer .boxbody .boxitem{
  display: flex;
  width: 100%;
  border-bottom: 1px solid hsla(0,0%,100%,.5);
  border-left: 1px solid hsla(0,0%,100%,.5);
  border-right: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .boxbody .boxitem .left {
  width: 20%;
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
}
.bodycontainer .boxbody .boxitem .center{
  width: 60%;
  display: flex;
  padding: 5px;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
  border-left: 1px solid hsla(0,0%,100%,.5);
  border-right: 1px solid hsla(0,0%,100%,.5);
}
.bodycontainer .boxbody .boxitem .right{
  width: 20%;
  display: flex;
  padding: 10px;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  color: #fff;
  font-size: 14px;
}
.bodycontainer .formbuttoncontainer{
  width: 100%;
  margin-top: 50px;
  margin-bottom: 20px;
  justify-content: flex-end;
}
.bodycontainer .formbuttoncontainer .loginbtn {
  width: 100px;
  height: 32px;
  background-color: #e8cbed;
  padding: 0 8px;
  border: 1px solid rgba(93,69,110,.6);
  border-radius: 4px;
  color: #513b5a;
  font-size: 14px;
  justify-content: space-between;
  cursor: pointer;
}
</style>
